import ScheduledTasks from "./ScheduledTasks";

// Thin wrapper so we can keep the existing form logic in ScheduledTasks
// while mounting it under a dedicated route for creating schedules.
const ScheduleCreate = () => {
  return <ScheduledTasks mode="create" />;
};

export default ScheduleCreate;

